// remove this when we fix the for.
/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import './PaymentSection.css';

class PaymentSection extends PureComponent {
  componentDidMount() {
    // Relying on jquery included from the outside.
    // eslint-disable-next-line no-undef
    this.$el = $(this.el);
    if (this.$el.material_select) {
      this.$el.material_select();
    }
  }
  componentWillUnmount() {
    if (this.$el.material_select) {
      this.$el.material_select('destroy');
    }
  }
  render() {
    return (
      <div className="white-box item-box payment-section">
        <div className="inner">
          <div className="row form-row">
            <div className="col s12">
              <div className="box-title">
                <h2>Payment</h2>
              </div>
              <div className="row form-row source-row">
                <fieldset>
                  <div className="input-field col s12 m7 l8">
                    <select
                      ref={(el) => {
                        this.el = el;
                      }}
                      id="paymentSource"
                      defaultValue="0x86fa049857E0209167d9e616F7eb3b3b78ecFdB0"
                    >
                      <option value="" disabled>
                        Payment Source
                      </option>
                      <option value="0x86fa049857E0209167d9e616F7eb3b3b78ecFdB0">
                        0x86fa049857E0209167d9e616F7eb3b3b78ecFdB0
                      </option>
                      <option value="0x06012c8cf97beda7deae237070f9587f8e7a266d">
                        0x06012c8cf97beda7deae237070f9587f8e7a266d
                      </option>
                      <option value="0x83B8717619eDFF639c9687411f1bA71fbA7EB6c8">
                        0x83B8717619eDFF639c9687411f1bA71fbA7EB6c8
                      </option>
                    </select>
                    <label htmlFor="paymentSource">Payment Source</label>
                  </div>
                  <div className="input-field col s12 m5 l4">
                    <div className="balance-block">
                      <span className="text">Balance</span>
                      <span className="value">1400 CAT</span>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div className="row form-row info-row">
                <fieldset>
                  <div className="input-field col s12 m7 l8">
                    <div className="payment-info-block">
                      <div className="payment-info-item">
                        <span className="text">ERC20 Token Creation</span>
                        <span className="value">10 CAT</span>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>
        </div>
        <div className="amount-block">
          <span className="text">Total Payment Due</span>
          <span className="value">10 CAT</span>
        </div>
      </div>
    );
  }
}

export default PaymentSection;



// WEBPACK FOOTER //
// ./src/components/PaymentSection.js